<template>
  <div>
    <slider />

    <section class="Mayor-video-msg">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-5">
            <b-modal size="lg" v-model="videoModal" footer-class="removed">
              <video width="100%" alt="" controls>
                <source
                  :src="require('@/assets/videos/main_video.mp4')"
                  type="video/mp4"
                />
                <source
                  :src="require('@/assets/videos/main_video.mp4')"
                  type="video/ogg"
                />
              </video>
            </b-modal>
            <!--Mayor Msg Start-->
            <div style="z-index: 2" class="city-tour bg-white p-1 image_ngo">
              <div
                v-if="loading"
                style="
                  height: 180px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <b-spinner
                  style="width: 3rem; height: 3rem"
                  class="mr-1"
                  label="Large Spinner"
                />
              </div>
              <img
                v-else
                height="140px"
                class="bg-white"
                alt=""
                :src="require('@/assets/images/logo/ngo-logo.png')"
                style="position: relative; z-index: 2"
                controls
              />
            </div>
          </div>
          <div class="col-md-8 col-sm-7">
            <div class="Mayor-welcome">
              <h5>عن منصة تشارك</h5>
              <p class="mx-1 text-align-justify">
                المنصة الوطنية الإلكترونية للمنظمات غير الحكومية التي هي صلة
                الوصل المباشرة والشفافة بين الجهات المانحة والمتبرعين من داخل
                وخارج سوريا من جهة وبين المؤسسات والجمعيات المعنية بإيصال
                المساعدات وتنفيذ البرامج التنموية من جهة آخرى وهي الطريقة
                المعاصرة التي تؤمن كل المعلومات اللازمة لكل متبرع وتسهل عملية
                التبرع من وقت وجهد وكل شخص قادر على إختيار الطريقة الأنسب للتبرع
                إما عن طريق المنصة أو بشكل مباشر .
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="loadingOrg" class="container">
      <div class="d-flex justify-content-center flex-wrap">
        <b-skeleton
          v-for="n in 10"
          :key="n"
          height="225px"
          width="250px"
          class="m-1"
        >
        </b-skeleton>
      </div>
    </section>

    <section class="pt-3 depart-info" v-else>
      <div class="container d-flex flex-column justify-content-between">
        <div class="title-style-3">
          <h3 class="font-weight-bolder">{{ $t("browseOrganizations") }}</h3>
        </div>
        <div
          class="d-flex flex-column align-items-center justify-content-between flex-wrap"
        >
          <div class="d-flex align-items-center">
            <b-input-group class="input-group-merge search_ngo">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                size="lg"
                :placeholder="$t('searchAnOrganization')"
                v-model="filtred"
              />

              <b-input-group-append is-text v-if="filterLoading">
                <b-spinner label="Loading..." />
              </b-input-group-append>
            </b-input-group>
            <div class="cursor-pointer mx-1" is-text>
              <b-button
                variant="primary"
                class="search_ngo_button"
                @click="$router.push({ name: 'ngo-list' })"
              >
                <feather-icon icon="ListIcon" class="search_ngo_button_icon" />
                {{ $t("listOfOrganizations") }}
              </b-button>
            </div>
          </div>
          <div v-if="loadingPagination">
            <div class="d-flex justify-content-center flex-wrap">
              <b-skeleton
                v-for="n in 10"
                :key="n"
                class="skeleton_ngo_list mx-1 mb-1"
              >
              </b-skeleton>
            </div>
          </div>
          <div v-if="loadingPagination"></div>
          <div class="d-flex justify-content-center flex-wrap" v-else>
            <div
              v-if="filterLoading"
              class="d-flex justify-content-center flex-wrap"
              style="flex-wrap: wrap"
            >
              <div v-for="n in 10" :key="n">
                <b-skeleton height="225px" width="250px" class="m-1">
                </b-skeleton>
              </div>
            </div>
            <template v-else>
              <div v-for="org in getOrg.data" :key="org.id" class="m-1">
                <ngo-card
                  :id="org.id"
                  :name_ngo="org.name_ar"
                  :logo="org.logo"
                ></ngo-card>
              </div>
            </template>
          </div>
          <alert
            v-if="getOrg.data.length === 0 && filtred !== ''"
            :massage="$t('alert')"
            class="mb-2"
          ></alert>
        </div>

        <div>
          <pagination
            v-model="currentPage"
            :total-rows="getOrg.pagination.total_row"
            :per-page="getOrg.pagination.per_page"
            align="center"
            class="pagination_class"
          >
          </pagination>
        </div>
      </div>
    </section>
    <!-- donation campaigns -->
    <section class="py-3 depart-info">
      <div class="container">
        <b-row v-if="loadingCampaigns" class="w-100">
          <b-col v-for="n in 3" :key="n" xl="4" lg="6" md="6" sm="12">
            <Skeleton />
          </b-col>
        </b-row>
        <div v-else>
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="font-weight-bolder mb-3">حملات التبرع</h3>
            <b-button to="/donation" variant="info"
              >عرض كافة حملات التبرع</b-button
            >
          </div>

          <alert
            v-if="campaigns.length === 0"
            class="w-100"
            :massage="$t('alert')"
          ></alert>
          <template v-else>
            <b-row cla>
              <b-col
                xl="4"
                lg="6"
                md="6"
                sm="12"
                v-for="(item, i) in campaigns"
                :key="i"
              >
                <card-donation
                  class="donation-card"
                  :item="item"
                ></card-donation>
              </b-col>
            </b-row>

            <!-- <pagination
              v-if="campaignsPagination.total_row"
              :total-rows.sync="campaignsPagination.total_row"
              :per-page.sync="campaignsPagination.per_page"
              align="center"
            >
            </pagination> -->
          </template>
        </div>
      </div>
    </section>

    <section class="container p75-50">
      <div v-if="loadingAbout" class="my-1 mx-1">
        <b-skeleton animation="fade" width="20%"></b-skeleton>
        <b-skeleton
          v-for="n in 4"
          :key="n"
          animation="fade"
          width="85%"
        ></b-skeleton>
      </div>
      <div class="container" v-else>
        <div class="title-style-3">
          <h3 class="font-weight-bolder">
            {{ ngoFoundingOrganization.title }}
          </h3>
        </div>
        <div class="row">
          <div class="col-md-9">
            <p class="text-align-justify">
              {{ ngoFoundingOrganization.content }}
            </p>
          </div>
          <div class="col-md-3">
            <b-button @click="$router.push('/ngo-create-steps')" variant="info"
              ><feather-icon icon="PlusIcon" size="16" class="mx-25" />{{
                $t("organizationsStablishmingSteps")
              }}
            </b-button>
          </div>
        </div>
      </div>
    </section>
    <!-- </div>
    </div> -->
  </div>
</template>

<script>
import Slider from "../../components/Slider.vue";
import { AlertCircleIcon } from "vue-feather-icons";
import debounce from "lodash.debounce";
import SkeletonHomeOrg from "../../components/SkeletonHomeOrg.vue";
import { BSpinner } from "bootstrap-vue";
import ngoMap from "@/components/ngo-map.vue";
import NgoCard from "../../components/NgoCard";
import Alert from "@/components/Alert";
import Skeleton from "../../components/Skeleton.vue";
import CardDonation from "../../components/CardDonation.vue";
import Pagination from "@/components/pagination";
import { mapGetters } from "vuex";
import {
  BNav,
  BRow,
  BCol,
  BNavItem,
  BFormGroup,
  BModal,
  BInputGroupPrepend,
  BButton,
  BInputGroupAppend,
  BInputGroup,
  BFormInput,
  BPagination,
  BDropdown,
  BDropdownItem,
  BAlert,
  BSkeleton,
  BCard,
} from "bootstrap-vue";

export default {
  components: {
    Slider,
    BNav,
    BRow,
    BCol,
    BNavItem,
    BFormGroup,
    BModal,
    BInputGroupPrepend,
    BButton,
    BInputGroupAppend,
    BInputGroup,
    BFormInput,
    BPagination,
    BDropdown,
    BDropdownItem,
    BAlert,
    AlertCircleIcon,
    SkeletonHomeOrg,
    BSpinner,
    ngoMap,
    NgoCard,
    Alert,
    Pagination,
    BSkeleton,
    BCard,
    Skeleton,
    CardDonation,
  },
  data() {
    return {
      currentPage: 1,
      filtersModal: false,
      filtred: "",
      videoModal: false,
    };
  },
  computed: {
    ...mapGetters("NgoHome/main", [
      "campaigns",
      "campaignsPagination",
      "loadingCampaigns",
    ]),
    getOrg() {
      return this.$store.getters["NgoHome/main/ngoOrganizations"];
    },
    ngoAboutPlatform() {
      return this.$store.getters["NgoHome/main/ngoAboutPlatform"];
    },
    ngoFoundingOrganization() {
      return this.$store.getters["NgoHome/main/ngoFoundingOrganization"];
    },
    loadingOrg() {
      return this.$store.getters["NgoHome/main/loadingOrg"];
    },
    loadingPagination() {
      return this.$store.getters["NgoHome/main/loadingPagination"];
    },
    loadingAbout() {
      return this.$store.getters["NgoHome/main/loadingAbout"];
    },
    filterLoading() {
      return this.$store.getters["NgoHome/main/filterLoading"];
    },
    loading() {
      return this.$store.getters["NgoHome/main/loading"];
    },
  },
  methods: {
    numberPage() {
      this.$store.dispatch(`NgoHome/main/getOrganizationsFilter`, {
        currentPage: this.currentPage,
        filter: this.filtred,
      });
    },
    paginationChange() {
      this.$store.dispatch(`NgoHome/main/getOrganizationsPagination`, {
        currentPage: this.currentPage,
        filter: this.filtred,
      });
    },
  },
  watch: {
    filtred: debounce(function (value) {
      this.currentPage = 1;
      this.numberPage();
    }, 500),
    currentPage(value) {
      this.filtred = "";
      this.paginationChange();
    },
  },
  created() {
    this.$store.dispatch(`NgoHome/main/getOrganizations`, {
      currentPage: this.currentPage,
      filter: this.filtred,
    });
    this.$store.dispatch(`NgoHome/main/getAboutPlatform`);
    this.$store.dispatch(`NgoHome/main/getFoundingOrganization`);
    this.$store.dispatch(`NgoHome/main/getShuffledCampaigns`);
  },
};
</script>

<style lang="scss">
.donation-card {
  &.card {
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
  }
}
p {
  margin-left: 15px;
  margin-right: 15px;
}
.skeleton_ngo_list {
  height: 225px;
  width: 225px;
  margin: 5px;
}
.ngo_about {
  font-size: 16px;
  line-height: 24px;
  text-align: justify;
}
.last_title {
  text-align: justify;
  font-weight: bold;
  margin-left: 12px !important;
  margin-right: 12px !important;
  font-size: 14px !important;
}
.pagination_class {
  margin-top: 16px;
  margin-bottom: 22px;
}
.search_ngo {
  width: 50%;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 500px;
}
.search_ngo_button {
  height: 42px !important;
}
.deprt-icon-box {
  width: 250px !important;
}
@media (max-width: 481px) {
  .search_ngo_button {
    width: 105px;
    padding-left: 2px;
    padding-right: 2px;
    font-size: 12px;
  }

  .skeleton_ngo_list {
    width: 100px;
    height: 150px;
  }
  .search_ngo_button_icon {
  }

  .name_list_min {
    font-size: 10px !important;
  }
  .img_list_min {
    height: 50px !important;
    width: 50px !important;
    margin: auto;
  }
  .button_view_info a {
    font-size: 6px !important;
  }
  .deprt-icon-box {
    padding: 5px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px !important;
    width: 110px !important;
  }
  .search_ngo {
    width: 80%;
  }
  .video_mine {
    video {
      margin-top: 0px !important;
      width: 100%;
      height: 195px !important;
    }
  }
}
.plat-about {
  h4 {
    font-size: larger;
    padding: 4px 0px;
  }
  li {
    padding: 4px 0px;
    list-style: disc;
  }
}
.video_mine {
  video {
    position: relative;
    z-index: 1;
    margin-top: -90px;
    box-shadow: 6px 10px 20px rgba(0, 0, 0, 0.17);
    -webkit-box-shadow: 6px 10px 20px rgba(0, 0, 0, 0.17);
    height: 240px;
    // width: 320px;
    border-radius: 7px;
  }
}
</style>
